import React from 'react';

const GeneralInfo = () => {
  return (
    <div className="panel py-16 px-6 lg:px-12" style={{ backgroundColor: '#f5f0eb' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-8" data-aos="fade-up" data-aos-duration="1700">
            <p className="text-lg md:text-xl font-light mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
              We believe childhood should be filled with warmth, care, and meaningful moments. In our homes, children are
              supported to build positive memories and experiences that last a lifetime. Our calm, stable, and supportive
              environments combine high-quality care with tailored therapeutic support, helping young people feel safe,
              understood, and emotionally secure, so they can begin to grow in confidence, trust, and resilience.
            </p>

            <p className="text-lg md:text-xl font-light mb-6 leading-relaxed" style={{ color: '#6b7280' }}>
              We offer placements ranging from solo provision to small four-bed homes, carefully matched to the child, home,
              and manager to ensure the right fit. Our focus is on nurturing healthy, balanced lives, positive relationships,
              and a sense of belonging within a family-style home.
            </p>

            <p className="text-lg md:text-xl font-light mb-10 leading-relaxed" style={{ color: '#2b3d57' }}>
              Using evidence-based approaches, our therapeutic support addresses each child's unique needs, fostering
              emotional regulation, trauma recovery, and overall psychological wellbeing.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="/our-homes"
                className="px-6 py-3 rounded-full border-2 border-[#2f4c74] text-[#2f4c74] transition duration-300 hover:bg-[#2f4c74] hover:text-white"
              >
                Explore Our Homes
              </a>
              <a
                href="/contact-us#contact"
                className="px-6 py-3 rounded-full bg-[#2f4c74] text-white transition duration-300 hover:opacity-90"
              >
                Contact Us Today
              </a>
            </div>
          </div>

          {/* Right Column - Vision and Mission Statement Boxes */}
          <div className="lg:col-span-4" data-aos="fade-up" data-aos-duration="1700" data-aos-delay="200">
            <div className="space-y-6">
              <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-xl md:text-2xl font-bold mb-6" style={{ color: '#2b3d57' }}>
                  Vision
                </h3>
                <p className="text-base md:text-lg leading-relaxed" style={{ color: '#2b3d57' }}>
                  To be recognised as a trusted and transformative provider of therapeutic residential care,
                  empowering vulnerable children and young people to thrive, develop resilience, and achieve meaningful,
                  fulfilling lives.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
                <h3 className="text-xl md:text-2xl font-bold mb-6" style={{ color: '#2b3d57' }}>
                  Mission
                </h3>
                <p className="text-base md:text-lg leading-relaxed" style={{ color: '#2b3d57' }}>
                  To provide compassionate, therapeutic residential care that empowers vulnerable children and young people
                  to heal, grow, and achieve their full potential.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralInfo;
